module.exports = __webpack_public_path__ + "static/media/Pickup_Image.3a47df03.png";